import React, { Component } from 'react'

// import '@/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area/virtual-trading-area-right.scss'
import { connect } from 'react-redux'

class VirtualTradingAreaRight extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rankData: [
                { name: '412*123456', value: '128,888,467', percentage: '487%' },
                { name: '412*123456', value: '128,888,467', percentage: '487%' },
                { name: '412*123456', value: '128,888,467', percentage: '487%' },
                { name: '412*123456', value: '128,888,467', percentage: '487%' },
                { name: '412*123456', value: '128,888,467', percentage: '487%' },
                { name: '412*123456', value: '128,888,467', percentage: '487%' },
            ]
        }
    }
    render() {
        const { rankData } = this.state
        const { language } = this.props
        return (
            <div className='virtual-trading-area-right' >
                <span className='head' > {language.virtual_trading_total_ranking} </span>
                <div className='ranking'>
                    {rankData.map((item, index) => {
                        return (
                            <div className='ranking-single' key={index}>
                                <span> {index + 1} </span>
                                <div> {item.name} </div>
                                <div> {item.value} </div>
                                <div> {item.percentage} </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}


export default connect(state => ({
    language: state.app.language,
}),
    dispatch => ({

    }))(VirtualTradingAreaRight)